import React from "react";
import LabelField from "component/labelField/LabelField";
import t from "module/translations";

interface Props {
  module: string;
}

const TrainingModuleLabelField: React.FC<Props> = ({ module }) => {
  return (
    <LabelField
      {...{
        caption: t.competencyManagement.training.moduleText,
        label: module,
      }}
    />
  );
};

export default React.memo(TrainingModuleLabelField);
